/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { SVGProps } from 'react';

export const SwapItem = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <mask
      id="mask0_9131_8546"
      //style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="2"
      y="0"
      width="12"
      height="8"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.92193 0L8.83489 0.966259L10.5977 2.53319H7.0721C4.52824 2.53319 2.45947 4.37209 2.45947 6.6333V8H3.99701V6.6333C3.99701 5.12582 5.37696 3.89989 7.0721 3.89989H10.5977L8.83489 5.46681L9.92193 6.43307L13.5405 3.21654L9.92193 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_9131_8546)">
      <rect x="2.6" width="12" height="8" fill="#F26D0D" />
    </g>
    <mask
      id="mask1_9131_8546"
      // style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="2"
      y="8"
      width="12"
      height="8"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92791 13.4668H5.40233L7.16512 15.0337L6.07808 16L2.45947 12.7835L6.07808 9.56693L7.16512 10.5332L5.40233 12.1001H8.92791C10.623 12.1001 12.003 10.8742 12.003 9.3667V8H13.5405V9.3667C13.5405 11.6279 11.4718 13.4668 8.92791 13.4668Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_9131_8546)">
      <rect width="12" height="8" transform="matrix(1 0 0 -1 2.00049 16)" fill="#F26D0D" />
    </g>
  </svg>
);
